import React, { useEffect, useState } from 'react'
import ImageSlider from '../components/ImageSlider'
import { formatDate } from '../helper/formatDate'
import OrganiserInfo from '../components/OrganiserInfo'
import JudgesList from '../components/JudgesList'
import CompetitionsSection from '../components/CompetitionsSection'
import ClassesSection from '../components/ClassesSection'
import CustomButton from '../components/CustomButton';
import { useLocation, useNavigate } from 'react-router'
import axiosBackend from '../axios/axios'
import CategoriesSection from '../components/CategoriesSection'
import PrizeMoney from '../components/PrizeMoney'
import { Link } from 'react-router-dom'
import { useTranslate } from '../components/TranslationText'
import HorizentalSpacer from '../components/HorizentalSpacer'
import Popup from 'reactjs-popup'
import Album from '../components/Album'
import Lightbox from 'react-18-image-lightbox';
import "react-18-image-lightbox/style.css";
import axiosUmbraco from '../axios/axiosUmbraco'
import GallerySection from '../components/GallerySection';


const MediaBaseURL = process.env.REACT_APP_BACKEND_API;
const GalleryId = process.env.REACT_APP_GALLARY_ID;
export default function ShowDetailsPage() {
    const { translate } = useTranslate();
    const navigate = useNavigate();
    const [showData, setShowData] = useState({});
    const [loaded, setLoaded] = useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const nowDate = new Date();
    const [images, setimages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const [showMediaData, setShowMediaData] = useState([]);
    const [newUpdate, setNewUpdate] = useState(0);


    const showID = searchParams.has("id")
        ? searchParams.get("id")
        : false;

    const accessToken = localStorage.getItem('accessTokenforECUP') ?? false;



    async function getShowDetails() {
        try {
            const res = await axiosBackend.get(`/api/Show/GetShowEntrybyId?id=${showID}`);
            if (res.status == 200) {
                if (res.data.responseCode == 200) {
                    setShowData(res.data.result);
                    setLoaded(true);
                }
            }

        } catch (error) {
            console.debug('error', error);
        }
    }

    async function getShowGallery() {
        try {
            const response = await axiosUmbraco.get(`umbraco/delivery/api/v1/content?fetch=children:${GalleryId}&skip=0&take=100000000`)
            const formatedData = response.data.items.map((item) => (
                {
                    albumName: item?.properties?.albumName ?? "",
                    albumMedia: item?.properties?.albumCover ?? [],
                    albumId: item?.id ?? '',
                    albumStartDate: formatDate(item?.properties?.eventStartDate) ?? '',
                    albumEndDate: formatDate(item?.properties?.eventEndDate) ?? "",
                    eventId: item?.properties?.eventId ?? ""
                }
            ))

            const filterdShows = formatedData.filter((item) => item.eventId == showID);
            setShowMediaData(filterdShows);
        } catch (error) {
            console.error('error in getting Gallery:', error);
        }

    }

    useEffect(() => {
        getShowDetails();

        if (showMediaData.length <= 0) {
            getShowGallery();
        }
    }, [])


    // media Show
    const handleHorseMedia = (index, albumMedia) => {
        setPhotoIndex(index);
        setimages(albumMedia.map((media) => MediaBaseURL + media.url));
        setIsOpen(true);
    };
    const handleHorseimages = (images) => {
        setPhotoIndex(0);
        setimages(images.map((media) => media?.imageUrl));
        setIsOpen(true);
    };

    return (
        loaded &&
        <>
            {isOpen && images.length > 0 && (
                <div>
                    <Lightbox
                        key={'imagesLoader'}
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => setIsOpen(false)}
                        onMovePrevRequest={() =>
                            setPhotoIndex((photoIndex + images.length - 1) % images.length)
                        }
                        onMoveNextRequest={() =>
                            setPhotoIndex((photoIndex + 1) % images.length)
                        }
                    />
                </div>
            )}
            <div className='row pt-3'>
                {/* <h2 className='roboto-light contentGray' >{showData?.showName}</h2> */}
                <h2 className='roboto-custom-black col-sm-8 col-12 fw-bold' >{showData?.showName}
                    <div className='col-12 mb-2 d-flex flex-wrap grayText mt-2' >
                        <span className='ms-sm-0 ms-1' style={{ fontSize: 16, fontWeight: 400 }}><i className="fa fa-calendar" aria-hidden="true"></i> {formatDate(showData?.startDate ?? new Date())}</span>
                        <span className='ms-sm-3 ms-1 ' style={{ fontSize: 16, fontWeight: 400 }} ><i className="fa fa-calendar" aria-hidden="true"></i> {formatDate(showData?.endDate ?? new Date())}</span>
                        <span className='ms-sm-3 ms-1' style={{ fontSize: 16, fontWeight: 400 }}><i className="fa fa-map-marker" aria-hidden="true"></i> {showData?.countryName}</span>
                        <span className='ms-sm-3 ms-1' style={{ fontSize: 16, fontWeight: 400 }}><i className="fa fa-trophy" aria-hidden="true"></i> {showData?.showRank}</span>
                        {!!showData?.termsAndConditions &&
                            <Popup
                                trigger={
                                    <div style={{ fontSize: 16, fontWeight: 400, cursor: 'pointer' }} className='ms-auto text-primary text-decoration-underline'><i className="fa fa-info-circle" aria-hidden="true"></i> {translate('web.particaptionTermsAndConditions', 'Particapte Conditions')}</div>
                                }
                                modal
                                lockScroll={true}
                                closeOnDocumentClick={true}
                                closeOnEscape
                                contentStyle={{ background: 'rgba(0,0,0,0)' }}
                                overlayStyle={{ background: 'rgba(0,0,0,0.7)' }}


                            >
                                {(close) =>
                                    <div className='container bg-white border-success' style={{ maxWidth: 1300, borderRadius: 25 }} >
                                        <div className='row py-4 px-2 border border-success pe-3' style={{ borderRadius: 25 }} >
                                            <div className='col-12 mt-3 max-height-80-vh' style={{ minHeight: '50vh' }} dangerouslySetInnerHTML={{ __html: showData?.termsAndConditions }} />
                                            <div className='text-center'>
                                                <CustomButton key={'submit'} type='submit' htmlText={`<i class="fa fa-times"></i>`} className='btn-danger rounded-circle position-absolute closePopUpButton' onClick={close} />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </Popup>
                        }
                    </div>
                </h2>
                <div className='roboto-custom-black col-sm-4 col-12' >
                    {showData?.isShowRegisterStarted ?
                        <>
                            {!!accessToken ?
                                <CustomButton type='navigate' htmlText={`${translate('web.participateNow', 'Participate Now')}`} className='btn-success participateButton' key={'participate'} onClick={() => navigate(`/showEntry?id=${showID}`)} />
                                :
                                <CustomButton type='navigate' htmlText={`${translate('web.participateNow', 'Participate Now')}`} className='btn-success participateButton' key={'participate'} onClick={() => navigate(`/login?redirectUrl=/showEntry?id=${showID}`)} />
                            }
                        </>
                        :
                        ''
                    }
                    {(!!showData?.registerStartDate || !!showData?.registerEndDate || !!showData?.entryFees) &&
                        <div className='row'>
                            <div className='col-12 text-start mt-2 fw-bold roboto-light contentGray' >
                                {translate('web.registrationDates', 'Registration Dates')}
                            </div>
                            {!!showData?.registerStartDate &&
                                <div className='col-sm-6 col-12 my-1'>
                                    <div className='text-start'><i className="fa fa-calendar" aria-hidden="true"></i> {translate('web.from', 'From')} {formatDate(showData?.registerStartDate)}</div>
                                </div>
                            }
                            {!!showData?.registerEndDate &&
                                <div className='col-sm-6 col-12 my-1'>
                                    <div className='text-sm-end text-start'><i className="fa fa-calendar" aria-hidden="true"></i> {translate('web.to', 'To')} {formatDate(showData?.registerEndDate)}</div>
                                </div>
                            }
                            {!!showData?.entryFees &&
                                <div className='col-sm-6 col-12 my-1'>
                                    <div className='text-start'><i className="fa fa-money" aria-hidden="true"></i> {translate('web.fees', 'Fees')} {showData?.entryFees} {showData?.currency ?? ''}</div>
                                </div>
                            }
                        </div>
                    }
                </div>
                <div className='col-lg-8 col-md-6 col-sm-12'>
                    <ImageSlider
                        key={'slider'}
                        items={[
                            { type: 'video', link: showData?.liveLink },
                            { type: 'img', link: showData?.coverImage },
                        ]} />
                </div>
                <div className='col-lg-4 col-md-6 col-sm-12'>
                    <OrganiserInfo key={'orgnaiser Info'} data={showData} />
                    {showData?.isShowJudgesAdded &&
                        <JudgesList key={'judges List'} showId={showID} setNewUpdate={setNewUpdate} />
                    }
                </div>
                <HorizentalSpacer key={'h4'} />
                {nowDate >= new Date(showData?.startDate) &&
                    <CompetitionsSection key={'compititions'} showID={showID} />
                }
                {nowDate <= new Date(showData?.endDate) &&
                    <>
                        <CategoriesSection key={'categories'} showId={showID} />
                        <PrizeMoney showId={showID} key={'prizeMoney'} />
                        <HorizentalSpacer key={'h4'} />
                    </>
                }
                {!!showMediaData && showMediaData.length > 0 && (
                    <GallerySection key={'AblumSection'} translate={translate} showMediaData={showMediaData} handleHorseMedia={handleHorseMedia} />
                )}
                <ClassesSection key='classes' showID={showID} newUpdate={newUpdate} islive={showData?.isShowLive} handleHorseimages={handleHorseimages} />
            </div>
        </>
    )
}


